import React from 'react';
import { UPLOAD_VENDOR_DOCUMENTS } from '../useVendorDocumentsService';
import VendorDocumentsForm from './VendorDocumentsForm';
import { useVendorId } from 'domain/finance/vendors/routes';
import { UploadDocumentButton } from 'framework/documentStorage';
import { useDocumentStorageContext } from 'framework/documentStorage';

const UploadVendorDocButton = () => {
  const id = useVendorId();
  const { uploadDocument, getValidationSchema } = useDocumentStorageContext();

  return (
    <UploadDocumentButton
      permission={UPLOAD_VENDOR_DOCUMENTS}
      uploadMethod={uploadDocument}
      initialData={{
        vendorId: id,
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <VendorDocumentsForm />
    </UploadDocumentButton>
  );
};

export default UploadVendorDocButton;
